import type { ApiClient } from "../auth/apiClient";
import { CurrentUserSchema } from "./types";
import type { CurrentUser } from "./types";

export async function fetchCurrentUser(client: ApiClient): Promise<CurrentUser> {
    const response = await client.fetch("/me");
    if (!response.ok) {
        throw new Error(
            `Failed to fetch current user: ${String(response.status)} ${response.statusText}`,
        );
    }
    const json: unknown = await response.json();
    return CurrentUserSchema.parse(json);
}
